import React from "react";
import { Asset, Flex } from "@thenounproject/lingo-core";

import FontSample from "./elements/FontSample";

type Props = {
  asset: Asset;
  lazy?: boolean;
};

function AssetPreviewFont({ asset }: Props) {
  return (
    <Flex width="100%" height="100%" justifyContent="center" alignItems="center" overflow="hidden">
      <FontSample asset={asset} />
    </Flex>
  );
}

export default React.memo(AssetPreviewFont);
